"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstantSearch = InstantSearch;
var _react = _interopRequireDefault(require("react"));
var _IndexContext = require("../lib/IndexContext");
var _InstantSearchContext = require("../lib/InstantSearchContext");
var _useInstantSearchApi = require("../lib/useInstantSearchApi");
var _excluded = ["children"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function InstantSearch(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var search = (0, _useInstantSearchApi.useInstantSearchApi)(props);
  if (!search.started) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_InstantSearchContext.InstantSearchContext.Provider, {
    value: search
  }, /*#__PURE__*/_react.default.createElement(_IndexContext.IndexContext.Provider, {
    value: search.mainIndex
  }, children));
}